<template>
    <div class="systembody">
  <div style="margin-top: 30px;">
     <AgentMenu @barUploadItemSelected="openSelected" :routerSelected="routerSelected" />
  
  <FirstAgentComp v-if="itemSelected === 'page1'" />
  <SecondAgentComp v-if="itemSelected === 'page2'" />
  <ThirdAgentComp v-if="itemSelected === 'page3'" />
  </div>
  </div>
  </template>
  <script>
  import FirstAgentComp from '@/components/agent/FirstAgentComp'
  import SecondAgentComp from '@/components/agent/SecondAgentComp'
  import ThirdAgentComp from '@/components/agent/ThirdAgentComp'
  import Auth from '@/services/auth.service.js'
  import AgentMenu from '@/components/agent/AgentMenu'
  
  export default {
    name: 'agent',
    components: {
      AgentMenu,
      FirstAgentComp,
      SecondAgentComp,
      ThirdAgentComp
    },
    data: () => ({
      itemSelected: "page1",
      routerSelected: "",
    }),
    methods: {
      openSelected(itemNum) {
        this.itemSelected = itemNum;
      },
    },
    created() {
      document.title = 'סוכן | clickcall'
      const pageParam = this.$route.params.page;
      if (pageParam) {
        this.routerSelected = pageParam;
       this.openSelected(pageParam)
      }else{
        this.openSelected("page1")
      }
  
      let auth = Auth.checkAuth();
      if (!auth) {
        this.$router.replace({ name: "login" })
      }
    },
  }
  </script>
  <style scoped>
 
  </style>